var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine02UpHoverActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z",
    fill: "#009866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9302 2.54275C17.3668 2.68829 17.6027 3.16022 17.4572 3.59684L15.81 8.5385C15.2223 10.3016 12.9846 10.8298 11.6705 9.5157L10.4842 8.32944C10.0462 7.8914 9.30032 8.06748 9.10442 8.65517L7.4572 13.5968C7.31166 14.0335 6.83972 14.2694 6.40311 14.1239C5.96649 13.9783 5.73052 13.5064 5.87606 13.0698L7.52328 8.12813C8.11098 6.36504 10.3486 5.83681 11.6628 7.15093L12.849 8.33719C13.2871 8.77523 14.0329 8.59915 14.2288 8.01146L15.8761 3.06979C16.0216 2.63317 16.4935 2.39721 16.9302 2.54275Z",
    fill: "#1C3D45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine02UpHoverActive);
export default __webpack_public_path__ + "static/media/line_02_up_hover_active.2d8f1dafaded6bc32e1226babb0ad15b.svg";
export { ForwardRef as ReactComponent };